import { render, staticRenderFns } from "./regisAdmin.vue?vue&type=template&id=13979027"
import script from "./regisAdmin.vue?vue&type=script&lang=js"
export * from "./regisAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QItemSection,QMenu,QList,QItem,QPagination,QDialog,QFile,QCardActions,QIcon,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QItemSection,QMenu,QList,QItem,QPagination,QDialog,QFile,QCardActions,QIcon})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
